import * as Sentry from "@sentry/browser";

Sentry.init({
  dsn: window.envVariables.SENTRY_DSN,
  release: window.envVariables.HEROKU_SLUG_COMMIT,
});
